// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4774":"c1383c32","6313":"7e4e15bd","8005":"dc0eb021","9425":"b9530b1e"}[chunkId] + ".css";
};